import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ScreenPermission {
  Can_View: boolean;
  Can_Create: boolean;
  Can_Update: boolean;
  Can_Delete: boolean;
}

interface PermissionsState {
  loaded: boolean;
  data: Record<string, ScreenPermission>;
}

const savedPerms = (() => {
  try {
    const raw = typeof window !== "undefined" ? localStorage.getItem("permissions") : null;
    return raw ? (JSON.parse(raw) as Record<string, ScreenPermission>) : null;
  } catch { return null; }
})();

const initialState: PermissionsState = savedPerms
  ? { loaded: true, data: savedPerms }
  : { loaded: false, data: {} };

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissions: (state, action: PayloadAction<Record<string, ScreenPermission>>) => {
      state.loaded = true;
      state.data = action.payload;
    },
    clearPermissions: () => ({ loaded: false, data: {} }),
  },
});

export const { setPermissions, clearPermissions } = permissionsSlice.actions;
export default permissionsSlice.reducer;
